import React from 'react'
import Layout from '../../component/Layout';
import { t } from 'i18next';
import GetStarted from '../../component/GetStarted';

const CDNContainer = () => {
	return (
		<Layout title={t("get_started")} description={t("get_started_description")}>
			<GetStarted />
		</Layout>
	)
}

export default CDNContainer